import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=632727ee&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=632727ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632727ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632727ee')) {
      api.createRecord('632727ee', component.options)
    } else {
      api.reload('632727ee', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=632727ee&scoped=true&", function () {
      api.rerender('632727ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8JzuhB2N9G6vH/JS/comp/CookieBox.vue"
export default component.exports